// import BaseLayout from '@/components/layouts/BaseLayout'
import LayoutWithoutNavbar from '@/components/layouts/LayoutWithoutNavbar';

export default [
  {
    path: '/',
    component: LayoutWithoutNavbar,
    navbar: false,
    children: [
      {
        path: 'token',
        name: 'token',
        component: () => import('@/pages/Token/Token'),
      },
    ],
  },
];
